// useReducer with Typescript:
// https://github.com/hswolff/youtube/blob/master/videos/why-i-love-usereducer/src/LoginUseReducerTypeScript.tsx

import React, { useReducer, ReactNode } from 'react';
import { createContext } from 'use-context-selector';

type LicenseState = {
  verifiedLicense?: VerifiedLicense;
  setVerifiedLicense: (license: VerifiedLicense) => void;
};

export type VerifiedLicense = {
  licenseId: string;
  licensedTo: string;
  licenseStatus: 'active' | 'inactive' | 'expired';
  expiresOnDate: Date;
  denied: boolean;
};

const initialState: LicenseState = {
  setVerifiedLicense: () => {},
};

type LicenseAction = { type: 'SET_VERIFIED_LICENSE'; payload: VerifiedLicense };

function uiReducer(state: LicenseState, action: LicenseAction): LicenseState {
  switch (action.type) {
    case 'SET_VERIFIED_LICENSE':
      return {
        ...state,
        verifiedLicense: action.payload,
      };
    default:
      return state;
  }
}

export const LicenseContext = createContext(initialState as LicenseState);

export default function LicenseProvider(props: { children: ReactNode }) {
  const [state, dispatch] = useReducer(uiReducer, initialState);

  // Actions
  // reminder: always dispatch; otherwise, is a SELECTOR, not an ACTION
  function setVerifiedLicense(license: VerifiedLicense) {
    dispatch({
      type: 'SET_VERIFIED_LICENSE',
      payload: license,
    });
  }

  return (
    <LicenseContext.Provider
      value={{
        ...state,
        setVerifiedLicense,
      }}
    >
      {props.children}
    </LicenseContext.Provider>
  );
}
